import { BaseUrl, get, post } from "./api";

export const getStripePublishableKey = async () => {
     return await get(`api/StripeSettings/PublishableKey`, null,
         BaseUrl.Centerpoint);
}